<template>
  <div v-if="loading" class="text-center py-4">
    <b-spinner :label="$t('caricamento')"></b-spinner>
  </div>
  <div v-else class="pb-4 text-left">
    <!-- Manuali d'uso: l'ultima versione e le altre, ogni manuale è una riga
         di lista con il bottone di scaricamento -->
    <div class="section-head mb-3">
      <h2 class="section-title mb-0">{{ $t('manuali_uso') }}</h2>
    </div>
    <b-row v-if="manuals && manuals.length">
      <b-col cols="12" lg="6" class="mb-4">
        <section class="shadowedCard p-4 h-100">
          <h3 class="section-eyebrow mb-3">{{ $t('ultima_versione') }}</h3>
          <div v-if="latestGroup && latestGroup.length" class="list-stack">
            <div v-for="m in latestGroup" :key="m.id" class="list-row">
              <span class="list-row__icon" aria-hidden="true">
                <span class="cc-icon cc-icon--supporto"></span>
              </span>
              <div class="list-row__body">
                <div class="list-row__title">{{ labelFor(m) }}</div>
                <div v-if="m.description" class="list-row__meta">{{ m.description }}</div>
              </div>
              <div class="list-row__actions">
                <b-button size="sm" @click="downloadManual(m)">
                  <b-icon icon="download" aria-hidden="true" class="mr-1"></b-icon>
                  {{ languageLabel(m) }}
                </b-button>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">
            <b-icon icon="journal-x" class="empty-state__icon" aria-hidden="true"></b-icon>
            <p>{{ $t('nessun_manuale') }}</p>
          </div>
        </section>
      </b-col>

      <b-col cols="12" lg="6" class="mb-4">
        <section class="shadowedCard p-4 h-100">
          <h3 class="section-eyebrow mb-3">{{ $t('altre_versioni') }}</h3>
          <b-form-select
            :options="selectOptions"
            v-model="selectedRelease"
            class="mb-3"
            :aria-label="$t('altre_versioni')"
          />
          <template v-if="selectedGroup && selectedGroup.length">
            <b-button
              v-if="selectedGroup.length===1"
              size="sm"
              variant="outline-secondary"
              @click="downloadManual(selectedGroup[0])"
            >
              <b-icon icon="download" aria-hidden="true" class="mr-1"></b-icon>
              {{ $t('scarica_selezionato') }}
            </b-button>
            <div v-else class="list-stack">
              <div v-for="m in selectedGroup" :key="m.id" class="list-row">
                <span class="list-row__icon" aria-hidden="true">
                  <span class="cc-icon cc-icon--supporto"></span>
                </span>
                <div class="list-row__body">
                  <div class="list-row__title">{{ labelFor(m) }}</div>
                  <div v-if="m.description" class="list-row__meta">{{ m.description }}</div>
                </div>
                <div class="list-row__actions">
                  <b-button size="sm" variant="outline-secondary" @click="downloadManual(m)">
                    <b-icon icon="download" aria-hidden="true" class="mr-1"></b-icon>
                    {{ languageLabel(m) }}
                  </b-button>
                </div>
              </div>
            </div>
          </template>
          <b-button v-else :disabled="true" size="sm" variant="outline-secondary">
            {{ $t('scarica_selezionato') }}
          </b-button>
        </section>
      </b-col>
    </b-row>
    <!-- Fallback: i link di ambiente, se l'API non restituisce manuali -->
    <div v-else class="list-stack mb-4">
      <div v-if="manualeUrl" class="list-row">
        <span class="list-row__icon" aria-hidden="true">
          <span class="cc-icon cc-icon--supporto"></span>
        </span>
        <div class="list-row__body">
          <div class="list-row__title">{{ $t('scarica_versione_aggiornata') }}</div>
        </div>
        <div class="list-row__actions">
          <b-button
            variant="white"
            class="btn-icon btn-sm"
            :href="manualeUrl"
            target="_blank"
            rel="noopener"
            :title="$t('scarica_versione_aggiornata')"
            :aria-label="$t('scarica_versione_aggiornata')"
          >
            <b-icon icon="download" aria-hidden="true"></b-icon>
          </b-button>
        </div>
      </div>
      <div v-if="manualeUrlEnglish" class="list-row">
        <span class="list-row__icon" aria-hidden="true">
          <span class="cc-icon cc-icon--supporto"></span>
        </span>
        <div class="list-row__body">
          <div class="list-row__title">{{ $t('scarica_versione_inglese') }}</div>
        </div>
        <div class="list-row__actions">
          <b-button
            variant="white"
            class="btn-icon btn-sm"
            :href="manualeUrlEnglish"
            target="_blank"
            rel="noopener"
            :title="$t('scarica_versione_inglese')"
            :aria-label="$t('scarica_versione_inglese')"
          >
            <b-icon icon="download" aria-hidden="true"></b-icon>
          </b-button>
        </div>
      </div>
    </div>

    <!-- Video tutorial: una sezione per video -->
    <div v-if="scaricabili.video">
      <div class="section-head mb-3">
        <h2 class="section-title mb-0">{{ $t('video_tutorial') }}</h2>
      </div>
      <section v-for="video in scaricabili.video" :key="video.title" class="shadowedCard p-4 mb-4">
        <h3 class="section-title">{{ video.title }}</h3>
        <p>{{ video.description }}</p>
        <b-row>
          <b-col cols="12" lg="8">
            <b-embed
              type="video"
              controls
              :poster="'/assets/' + $root.scope + '/logo.svg'"
            >
              <source :src="video.path" type="video/mp4" />
            </b-embed>
          </b-col>
        </b-row>
      </section>
    </div>
  </div>
</template>


<script>
import { utilityService } from "@/_services";
export default {
  name: "GuidaOperatore",
  methods: {
    fetchData() {
      const self = this;
      // fetch scaricabili (video/altro)
      utilityService
        .getScaricabili(this.$root.scope)
        .then(function (res) {
          self.scaricabili = res.data.data;
          self.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          self.loading = false;
        });

      // fetch manuali specifici: copia della logica da GuidaCittadino
      utilityService
        .getManuals({ is_operatore: true })
        .then((res) => {
          const data = res?.data?.data || [];
          const arr = Array.isArray(data) ? data : [];
          const normalize = (d) => {
            if (!d) return null;
            const dt = new Date(d);
            if (isNaN(dt)) return String(d);
            return dt.toISOString().slice(0, 10);
          };
          this.manuals = arr.map((m) => ({ ...m, release_key: normalize(m.data_release) }));
        })
        .catch(() => {
          this.manuals = [];
        });
    },
    labelFor(m) {
      const parts = [];
      if (m.version) parts.push(`${m.version}`);
      parts.push(m.is_italian ? "IT" : "EN");
      if (m.data_release) {
        const d = new Date(m.data_release);
        if (!isNaN(d)) {
          const dd = d.toLocaleDateString('it-IT');
          parts.push(dd);
        }
      }
      return parts.join(" • ");
    },
    linkFor(m) {
      if (!m || !m.download_link) return this.manualeUrl || '#';
      try {
        const u = new URL(m.download_link);
        return m.download_link;
      } catch (e) {
        const be = process.env.VUE_APP_BE || '';
        return `${be.replace(/\/$/, '')}/storage/${m.download_link.replace(/^\//, '')}`;
      }
    },
    downloadFilename(m) {
      if (!m || !m.download_link) return '';
      const parts = (m.download_link || '').split('/');
      const original = parts[parts.length - 1] || m.version || 'manuale';
      return `${m.version || original}`;
    },
    downloadManual(m) {
      if (!m) return;
      const url = this.linkFor(m);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.download = this.downloadFilename(m) || '';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    groupByRelease(releaseKey) {
      if (!releaseKey) return [];
      return this.manuals.filter((x) => x.release_key === releaseKey || x.data_release === releaseKey);
    },
    labelForGroup(group) {
      if (!group || !group.length) return '';
      const m = group[0];
      const parts = [];
      if (m.version) parts.push(`${m.version}`);
      if (m.data_release) {
        const d = new Date(m.data_release);
        if (!isNaN(d)) parts.push(d.toLocaleDateString('it-IT'));
      }
      return parts.join(' • ');
    },
    languageLabel(m) {
      return m.is_italian ? (this.$t ? this.$t('scarica_versione_aggiornata') : 'IT') : (this.$t ? this.$t('scarica_versione_inglese') : 'EN');
    },
  },
  computed: {
    latestGroup() {
      if (!this.manuals || !this.manuals.length) return [];
      const releases = Array.from(new Set(this.manuals.map((m) => m.release_key).filter(Boolean)));
      if (!releases.length) return [];
      const latest = releases
        .map((r) => ({ r, d: new Date(r) }))
        .filter((x) => !isNaN(x.d))
        .sort((a, b) => b.d - a.d)[0];
      if (!latest) return [];
      return this.groupByRelease(latest.r);
    },
    selectOptions() {
      if (!this.manuals) return [];
      const releases = Array.from(new Set(this.manuals.map((m) => m.release_key).filter(Boolean))).sort((a, b) => new Date(b) - new Date(a));
      const latest = releases.length ? releases[0] : null;
      const others = releases.filter((r) => r !== latest);
      return others.map((r) => {
        const grp = this.groupByRelease(r);
        const suffix = (grp[0] && grp[0].version && grp[0].version.split('_').pop()) || r;
        const langs = grp.map((m) => (m.is_italian ? 'IT' : 'EN')).join(' / ');
        return { value: r, text: `${suffix} (${langs})` };
      });
    },
    selectedGroup() {
      return this.groupByRelease(this.selectedRelease);
    }
  },
  created() {
    this.fetchData();
  },
  data() {
    return {
      scaricabili: {
        manuali: null,
        video: null,
      },
      loading: true,
      // manuali specifici
      manualeUrl: process.env.VUE_APP_URL_MANUALE_OPERATORE,
      manualeUrlEnglish: process.env.VUE_APP_URL_MANUALE_PAZIENTE_ENG,
      manuals: [],
      selectedRelease: null,
    };
  },
};
</script>
